import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar, Typography, Box } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import Input from "../../../atoms/Input";
import { useLocation } from "react-router-dom";
import PrintComponent from "../../PrintComponent";
import DeliveryReceiptDownload from "./download";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import DynamicText from "../../../molecules/DynamicText";
import CommentIcon from "@mui/icons-material/Comment";

const DeliveryReceiptClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");
  const [surveyData, setSurveyData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data, mdKeys) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data,
      mediaKeys: mdKeys,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        setSnackbarMessage("Signature has been added successfully!");
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);




  const [isSignCanvas, setSignCanvas] = useState(false);
  //
  //
  const uploadFile = async (file) => {

      const fd = new FormData();
      fd.append("image", file);

      imageUploadClientPreview(fd, surveyId, formId, email, token)
        .then((res) => {
          let values = { ...formContent };
          values.clientSign = res?.data?.data?.key;
          setFormContent(values);

          setTimeout(() => {
            updateContent(values, [res?.data?.data?.key]);
          }, 1500);
          setIsLoading(false);
        })
        .catch((error) => {
          setSnackbarMessage(error?.response?.data?.message);
          setOpenSnackbar(true);

          if (error?.response?.data?.statusCode == 401) {
            setIsValid(false);
          }

          setIsLoading(false);
        });
    
  };



  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
          title="Delivery Receipt"
          hideBackButton={true}
          actions={
            <div className="d-flex gap-3">
              {formContent?.clientSign == "" && (
                 <Button
                    variant="contained"
                    onClick={() => setSignCanvas(true)}
                    sx={{ 
                        textTransform: "none", 
                        borderRadius: "var(--radius-md)", 
                        padding: "10px 24px",
                        fontWeight: 700,
                        backgroundColor: "var(--primary-color)",
                        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                        '&:hover': { backgroundColor: 'var(--primary-hover)' }
                    }}
                >
                    Upload Sign
                </Button>
              )}

              {!isEdit && (
                <Button
                  variant="contained"
                   onClick={() => {
                    if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
                    const newTitle = `Delivery-Receipt-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
                    document.title = newTitle;
                    
                    // Standardized delay for print and title restoration
                    setTimeout(() => {
                      window.print();
                      setTimeout(() => {
                        document.title = tempTitle;
                      }, 2000);
                    }, 500);
                  }}
                  disabled={isLoading}
                  sx={{ 
                    textTransform: "none", 
                    borderRadius: "var(--radius-md)", 
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--text-main)",
                    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                    '&:hover': { backgroundColor: '#000' }
                  }}
                  startIcon={<DescriptionIcon />}
                >
                  Save as PDF
                </Button>
              )}
            </div>
          }
        >
          {/* File Details Section */}
          <SectionHeader title="Receipt Details" icon={<DescriptionIcon />} />
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="File Ref"
                  isEdit={isEdit}
                  type="text"
                  value={formContent?.fileRef}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.fileRef = e.target.value;
                    setFormContent(values);
                  }}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Customer"
                  isEdit={isEdit}
                  type="text"
                  value={formContent?.clientName}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.clientName = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Date"
                  isEdit={isEdit}
                  type="date"
                  value={formContent?.date}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.date = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Organization"
                  isEdit={isEdit}
                  type="text"
                  value={formContent?.organization}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.organization = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
          </PremiumCard>

          {/* Shipment Details Section */}
           <SectionHeader title="Shipment Details" icon={<LocalShippingIcon />} />
           <PremiumCard sx={{ marginBottom: "32px" }}>
              <Grid container spacing={3}>
                 <Grid item xs={12} md={6} className="mb-3">
                    <label className="mb-1 d-block fw-bold text-secondary">Origin Address</label>
                    {isEdit ? (
                        <Input
                            id="originAddress"
                            type="text"
                            style="full-border-field"
                            value={formContent?.originAddress}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.originAddress = e.target.value;
                            setFormContent(values);
                            }}
                            inline={{ width: "100%" }}
                        />
                         ) : (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                            {formContent?.originAddress || "-"}
                            </Typography>
                         )}
                 </Grid>
                 <Grid item xs={12} md={6} className="mb-3">
                     <label className="mb-1 d-block fw-bold text-secondary">Destination Address</label>
                       {isEdit ? (
                        <Input
                            id="destinationAddress"
                            type="text"
                            style="full-border-field"
                            value={formContent?.destinationAddress}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.destinationAddress = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                            <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                             {formContent?.destinationAddress || "-"}
                             </Typography>
                         )}
                 </Grid>
                 <Grid item xs={12} md={6} className="mb-3">
                      <label className="mb-1 d-block fw-bold text-secondary">Commodity</label>
                        {isEdit ? (
                        <Input
                            id="commodity"
                            type="text"
                            style="full-border-field"
                            value={formContent?.commodity}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.commodity = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                               <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                 {formContent?.commodity || " - "}
                               </Typography>
                         )}
                 </Grid>
                 <Grid item xs={12} md={6} className="mb-3">
                      <label className="mb-1 d-block fw-bold text-secondary">No of Packages</label>
                         {isEdit ? (
                        <Input
                            id="noOfPackages"
                            type="text"
                            style="full-border-field"
                            value={formContent?.noOfPackages}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.noOfPackages = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                              <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.noOfPackages || "-"}
                               </Typography>
                         )}
                 </Grid>
                 <Grid item xs={12} md={6} className="mb-3">
                      <label className="mb-1 d-block fw-bold text-secondary">Mode of Shipments</label>
                         {isEdit ? (
                        <Input
                            id="modeOfShipment"
                            type="text"
                            style="full-border-field"
                            value={formContent?.modeOfShippment}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.modeOfShippment = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.modeOfShippment || "-"}
                               </Typography>
                         )}
                 </Grid>
                 <Grid item xs={12} md={6} className="mb-3">
                       <label className="mb-1 d-block fw-bold text-secondary">Weight/Volume</label>
                           {isEdit ? (
                        <Input
                            id="weightVolume"
                            type="text"
                            style="full-border-field"
                            value={formContent?.weightVolume}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.weightVolume = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                               <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.weightVolume || "-"}
                               </Typography>
                         )}
                 </Grid>
                  <Grid item xs={12} md={6} className="mb-3">
                       <label className="mb-1 d-block fw-bold text-secondary">Truck No.</label>
                         {isEdit ? (
                        <Input
                            id="truckNo"
                            type="text"
                            style="full-border-field"
                            value={formContent?.truckNo}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.truckNo = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                               <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                 {formContent?.truckNo || "-"}
                               </Typography>
                         )}
                  </Grid>
                  <Grid item xs={12} md={6} className="mb-3">
                       <label className="mb-1 d-block fw-bold text-secondary">Container</label>
                         {isEdit ? (
                        <Input
                            id="container"
                            type="text"
                            style="full-border-field"
                            value={formContent?.container}
                            onChange={(e) => {
                            let values = { ...formContent };
                            values.container = e.target.value;
                            setFormContent(values);
                            }}
                             inline={{ width: "100%" }}
                        />
                         ) : (
                               <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.container || "-"}
                               </Typography>
                         )}
                  </Grid>
              </Grid>
           </PremiumCard>
           
           <SectionHeader title="Remarks" icon={<CommentIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
                <DynamicText
                textAreaLabel="Remarks..."
                isEdit={isEdit}
                value={formContent?.remarks}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.remarks = e.target.value;
                  setFormContent(values);
                }}
              />
            </PremiumCard>

             {/* Signatures */}
              <PremiumCard>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6} className="text-center">
                    <div style={{ height: "90px" }} className="d-flex justify-content-center align-items-end">
                      {formContent.clientSign != "" && formContent.clientSign != undefined && (
                        <img
                          src={`${Bucket}${formContent.clientSign}`}
                          height={80}
                          width={200}
                          style={{ maxHeight: "80px", maxWidth: "100%", objectFit: "contain" }}
                        />
                      )}
                    </div>
                    <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                    <p className="my-1">
                      <b>{"Customer/Authorized"}</b>
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6} className="text-center">
                    <div style={{ height: "90px" }} className="d-flex justify-content-center align-items-end">
                      {formContent?.adminSign?.trim()?.length > 0 && (
                        <img
                          src={`${Bucket}${formContent.adminSign}`}
                          height={80}
                          width={200}
                          style={{ maxHeight: "80px", maxWidth: "100%", objectFit: "contain" }}
                        />
                      )}
                    </div>
                    <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                    <p className="my-1">
                      <b>{"Shelozon Movers Packers & Logistics Pvt Ltd."}</b>
                    </p>
                  </Grid>
                </Grid>
              </PremiumCard>

        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <DeliveryReceiptDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Add signature Modal */}
      {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}
      {/* /snackbar */}
    </>
  );
};

export default DeliveryReceiptClientSide;
